import { actionTypes } from './user-actions';

const defaultInitialState = {
  roles: [],
  loading: true,
  userPreferences: null,
};

export const reducer = (state = defaultInitialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_CURRENT_USER: {
      return payload;
    }
    case actionTypes.FETCH_USER: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.FETCH_USER_FULFILLED: {
      return {
        ...state,
        ...payload,
        loading: false,
      };
    }
    default:
      break;
  }
  return state;
};
